import {
  Box,
  DropdownOptions,
  FormProvider,
  ModalProvider,
  PaginationProvider,
  SearchProvider,
  SortProvider,
  TooltipPopup,
} from 'dash-ui';

import SaveSaleTeamUserModal from 'pages/external-sales/components/SaveSalesTeamUserModal/SaveSaleTeamUserModal';
import DeleteSaleTeamUserModal from 'pages/external-sales/components/DeleteSaleTeamUserModal/DeleteSaleTeamUserModal';
import SetSaleTeamUserStatusModal from 'pages/external-sales/components/SetSaleTeamUserStatusModal/SetSaleTeamUserStatusModal';

import ExternalSalesUsersHeader from './components/ExternalSalesUsersHeader/ExternalSalesUsersHeader';
import ExternalSalesUsersTable from './components/ExternalSalesUsersTable/ExternalSalesUsersTable';
import { FormFieldsList } from 'pages/external-sales/components/SaveSalesTeamUserModal/SaveSaleTeamUserModal.constants';


const ExternalSalesUsers = () => (
  <PaginationProvider>
    <SearchProvider>
      <SortProvider>
        <ModalProvider>
          <Box w="100%">
            <DropdownOptions />
            <TooltipPopup />
            <ExternalSalesUsersHeader />
            <ExternalSalesUsersTable />
            <FormProvider fieldsList={FormFieldsList}>
              <SaveSaleTeamUserModal />
            </FormProvider>
            <DeleteSaleTeamUserModal />
            <SetSaleTeamUserStatusModal />
          </Box>
        </ModalProvider>
      </SortProvider>
    </SearchProvider>
  </PaginationProvider>
);

export default ExternalSalesUsers;
